<template>
  <span>
    <div
      v-if="data.length"
      class="pt-1"
    >
      <p class="text-center text-primary">
        Product Categories - Application Count
      </p>
      <apexchart
        type="donut"
        height="380"
        :options="chartOptions"
        :series="seriesData"
      />
    </div>
    <div v-else>
      <p class="py-2 text-center text-primary">
        No data yet!
      </p>
    </div>
  </span>
</template>

<script>
import VueApexCharts from 'vue-apexcharts'

export default {
  components: {
    apexchart: VueApexCharts,
  },
  props: {
    data: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    labelsData() {
      return this.data.map(item => item.name)
    },
    seriesData() {
      return this.data.map(item => item.total)
    },
    chartOptions() {
      return {
        chart: {
          type: 'donut',
        },
        labels: this.labelsData,
        legend: {
          position: 'bottom',
          height: 120,
          itemMargin: {
            horizontal: 6,
            vertical: 2,
          },
        },
        dataLabels: {
          enabled: false,
        },
        responsive: [
          {
            breakpoint: 2550,
            options: {
              chart: {
                width: 420,
              },
              legend: {
                position: 'bottom',
              },
            },
          },
          {
            breakpoint: 480,
            options: {
              chart: {
                width: 320,
              },
              legend: {
                position: 'bottom',
              },
            },
          },
        ],
      }
    },
  },
}
</script>
